<template>
   <main-block> 
        <main-title class="page__title_center page__title_between">
            Compare page
            <button 
                class="main-btn main-btn_ml" 
                v-if="comparing != null && comparing.length > 0"
                @click="clear"
            >
                clear all
            </button>
        </main-title>
        
        <div class="compare" v-if="comparing">   
            <template  v-if="comparing.length > 0">
                <!-- COMPARE LIST START -->
                <main-list
                    :comments="false"
                    :compare="true"
                    :data="comparing" 
                    :allowDifferent="true"
                    :matches="matches"
                    v-if="comparing"
                />
                <!-- COMPARE LIST END -->
            </template> 
            <template v-else>
                <div>
                    <router-link class="main-btn main-btn_mt" to='/history'>Add a first one</router-link>
                </div> 
            </template> 
        </div>
    </main-block>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import mainList from '@/components/lists/main/ListItem';

export default {
    components: {
        mainList
    },
    computed: {
        ...mapGetters({
            comparing: 'comparing/comparing',
            matches: 'comparing/matches'
        })
    },
    methods: {
        ...mapActions({
            get: 'comparing/get',
            clear: 'comparing/clear'
        })
    },
    async created() {
        await this.get(); 
    }
}
</script>

<style lang="scss">
.compare {
    width: 97%; 
    height: calc(100% - 40px); 
    display: flex;
    overflow: hidden;
    &-params {
        max-width: 295px;
        min-width: 295px;
        width: 100%;
        height: 100%;
    } 
    
    &-radio { 
        margin-top: 7px;
    }
    &-items {
        width: 100%;
        height: 95%;
        display: flex;
        overflow-x: auto; 
    }

    &-item {
        max-width: 295px;
        min-width: 295px;
        width: 100%; 
        height: 100%; 
        &_left {
            background-color: red;
        }

        &__link {
            &:hover {
                text-decoration: underline;
            }
        }

        &__li {
            &_more {
                color: #16984a; 
            }

            &_less {
                color: #c13232; 
            }
        }

        &__actions {
            margin-bottom: 7px;
        }
        
        &__action {
            margin-left: 8px;
            display: inline-block;
            cursor: pointer;
        }

        &__head {
            width: 100%;
            height: auto;
            border-bottom: 1px solid rgba(178, 180, 183, 0.25);
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: flex-end;
            padding: 15px;
            border-right: 1px solid rgba(178, 180, 183, 0.25);

            &_left {
                height: 76px;
            }
        }

        &__body {
            width: 100%;
            height: 100%;  

            &_border {
                border-right: 1px solid rgba(178, 180, 183, 0.25);
            }
        }

        &__ul {
              
            li {
                padding: 10px;
                font-size: .875rem;
                line-height: 1.25rem;
                font-size: 14px;
            }

            &_title {
                font-weight: 600;
                font-size: 16px !important;
                background: #fafafa;
                height: 40px; 
            }
        }

        &__title {  
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;

            &_date {
                font-size: 13px;
            }
        }
    }
} 
</style>

<style>
.el-radio__inner::after { 
    left: 52% !important; 
}
</style>